import { connect } from 'react-redux'
import { createAuthStateToProps } from 'helpers/auth'

export default ({ actions, extraStateToProps, extraDispatchToProps } = {}) => {
  if (extraStateToProps) {
    console.warn('extraStateToProps used in ChildFormView container')
  }

  return (Component) => {
    const mapStateToProps = (state, props) => ({
      ...createAuthStateToProps(state, props),
      ...(extraStateToProps ? extraStateToProps(state, props) : {}),
    })

    const mapDispatchToProps = (dispatch, props) => ({
      newItem: (data) => Promise.resolve({ value: { data } }),
      getSettings: (params) => dispatch(actions.getSettings(params)),
      ...(extraDispatchToProps ? extraDispatchToProps(dispatch, props) : {}),
    })

    return connect(mapStateToProps, mapDispatchToProps)(Component)
  }
}
